import { useCart } from "../context/CartContext";
import "./WhatsAppButton.css";

function WhatsAppButton() {
  const { cartOpen } = useCart();
  const phoneNumber = "8296695604";
  const message = "Hi, I need help with bike rental 🏍️";

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappLink}
      className={`whatsapp-float${cartOpen ? " whatsapp-float--hidden" : ""}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
    >
      💬
    </a>
  );
}

export default WhatsAppButton;
